import axios from 'axios'
import { v4 as uuidv4 } from 'uuid'
import library from '../../../utils/Library'

export const createUserCognito = async (email) => {
  const TOKEN = sessionStorage.getItem('token')
  const URL =
    library.getBaseAPIUrl('e_auth') + '/create/createUserBaseAccountEAuth'

  const uuid = uuidv4()
  return await axios({
    url: URL,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    data: {
      username: email,
      password: 'X' + uuid
    }
  })
}
